<template>
    <section class="main-section">
        <slot v-if="this.$slots['mainSectionHead']" name="mainSectionHead" />
        <v-container v-else>
            <v-row v-if="this.$slots['tit']" no-gutters align="end" :class="titWrapClass" class="main-section__head">
                <v-col>
                    <tit-wrap-primary :dark="dark" class="pb-0">
                        <template #TitHead><slot name="titHead" /></template>
                        <slot name="tit" />
                    </tit-wrap-primary>
                </v-col>
                <v-col v-if="this.$slots['titLeft']" cols="12" lg="auto" class="mt-30px mt-lg-0">
                    <div data-aos="fade-up" data-aos-delay="500">
                        <slot name="titLeft" />
                    </div>
                </v-col>
            </v-row>
            <slot />
        </v-container>
        <slot v-if="this.$slots['mainSectionFoot']" name="mainSectionFoot" />
    </section>
</template>

<script>
import TitWrapPrimary from "@/components/publish/parents/typography/tit-wrap-primary.vue";

export default {
    props: {
        titWrapClass: { type: String, default: "text-center" },        
        dark: { type: Boolean, default: false, },
    },
    components: {
        TitWrapPrimary,
    },
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function () {},
    },
};
</script>

<style lang="scss" scoped>
.main-section {
    position: relative;
    padding: var(--page-section-padding-y) 0;
    .container {
        position: relative;
    }
    &--sm {
        padding: var(--page-section-padding-y-sm) 0;
    }
    &--first {
        padding-top: var(--contents-padding-top);
        margin-top: calc(var(--contents-padding-top) * -1);
    }
    &--last {
        padding-bottom: var(--contents-padding-bottom);
        margin-bottom: calc(var(--contents-padding-bottom) * -1);
    }
    &__head{
        padding-bottom: var(--tit-wrap-padding-bottom);
        &--sm{
            padding-bottom: var(--tit-wrap-padding-bottom-sm);
        }
    }
    &__bg {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        z-index: -1;
        display: block;
        width: 100vw;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
